import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sortIcons } from 'helpers/icon_helpers';
import type { ColumnConfig, SortDirection, SortState } from './types';

type DocTemplateColumnHeaderProps = {
  columnConfig: ColumnConfig,
  sortState: SortState,
  onSort: (sortKey: string, direction: SortDirection) => void,
};

export default function DocTemplateColumnHeader({ columnConfig, sortState, onSort }: DocTemplateColumnHeaderProps) {
  const handleSort = () => {
    if (!columnConfig.sortKey) return;
    const newDirection = sortState.name === columnConfig.sortKey && sortState.direction === 'asc'
      ? 'desc'
      : 'asc';
    onSort(columnConfig.sortKey, newDirection);
  };

  const sortable = !!columnConfig.sortKey;
  let icon = sortIcons.sort;

  if (sortState.name === columnConfig.sortKey) {
    icon = sortState.direction === 'asc' ? sortIcons.alpha.asc : sortIcons.alpha.desc;
  }

  return (
    <th
      className={sortable ? 'clickable text-nowrap' : 'text-nowrap'}
      onClick={handleSort}
    >
      {columnConfig.label}
      {sortable && <FontAwesomeIcon className="ms-1" icon={icon} />}
    </th>
  );
}
